import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DTypeTableField } from '@grupo-constant/next-dtype/form';
import { DTypeFormFieldComponent } from '../../dtype-field.model';


@Component({
    selector: 'table-field-component',
    templateUrl: './table-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeTableFieldComponent implements DTypeFormFieldComponent {

    @Input() field: DTypeTableField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;


    constructor() { }
}


